<template>
	<button
		:id="name"
		class="tab"
		:class="{ 'tab--active': isActive }"
		@click="selectTab()"
		:disabled="disabled"
		:aria-selected="isActive"
	>
		{{ label }}
	</button>
</template>

<script>
export default {
	name: 'Tab',
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: null,
		},
		name: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			activeTab: null,
		};
	},
	methods: {
		selectTab() {
			this.$parent.selected(this.name);
		},
	},
	computed: {
		isActive() {
			return this.activeTab === this.name;
		},
	},
	watch: {
		'$parent.active': {
			handler(tab) {
				this.activeTab = tab;
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.tab {
	display: inline-flex;
	padding: $b360-spacing-base;
	border: none;
	justify-content: center;
	@include typo--roboto__regular;
	font-size: $b360-font-size--base;
	color: $text-base-color;
	background-color: transparent;
	cursor: pointer;
	transition: box-shadow 0.25s;

	&:hover {
		color: $brand-blue;
	}

	&:focus,
	&:active,
	&--active {
		color: $brand-blue;
		border-bottom: 2px solid $brand-blue;
	}

	&:active,
	&--active {
		outline: none;
	}

	&:disabled,
	&:disabled:active {
		opacity: 0.65;
		cursor: not-allowed;
		&:hover {
			box-shadow: inset 0 -#{$b360-border-width-thick} 0 0
				$b360-color--gray__light;
		}
	}
}
</style>
